import { createI18n } from 'vue-i18n'

const messages = {
  ru: {
    auth: {
      dashboard_title: '443vpn.online',
      unified_title: 'Вход',
      unified_subtitle: 'Введите email — пришлём код для входа или регистрации',
      unified_hint: 'Нет аккаунта? Введите email — создадим при первом входе.',
      get_code: 'Получить код',
      enter_code: 'Введите код',
      change_email: 'Изменить email',
      back_to_email: 'Войти через email',
      via_email: 'Через Email',
      via_telegram: 'Войти через Telegram',
      code_sent_to: 'Мы отправили 6-значный код на',
      resend_code: 'Отправить код повторно',
      step2_passphrase: 'Шаг 2: кодовое слово',
      passphrase_create: 'Придумайте кодовое слово (мин. 4 символа)',
      save_passphrase: 'Сохранить кодовое слово',
      check_letters: 'Проверить буквы',
      change_word: 'Изменить слово',
      step3_totp: 'Шаг 3: код Proton Authenticator',
      secret: 'Секрет',
      enter_6digit: 'Введите 6-значный код',
      finish_login: 'Завершить вход',
      use_backup_code: 'Использовать резервный код',
      use_app_code: 'Ввести код из приложения',
      step1_telegram_otp: 'Шаг 1: получите одноразовый пароль в Telegram',
      telegram_otp_hint: 'Откройте бота и в меню нажмите «Одноразовый пароль». Код обновляется каждые 30 секунд.',
      go_to_bot: 'Перейти к боту',
      enter_bot_code: 'Введите код из бота',
      next: 'Далее',
      backup_codes_title: 'Резервные коды',
      backup_codes_warning: 'Сохраните эти коды в надёжном месте. Каждый код одноразовый.',
      copy_all_codes: 'Скопировать все коды',
      codes_saved: 'Я сохранил коды',
      enter_letter: 'букву №',
      enter_letters_prompt: 'Введите {letters} из вашего кодового слова',
      js: {
        otp_invalid: 'Код не подошёл или истёк. Запросите новый в Telegram.',
        otp_accepted_set: 'Код принят. Задайте кодовое слово.',
        otp_accepted_verify: 'Код принят. Подтвердите кодовое слово.',
        letters_mismatch: 'Буквы не совпали. Попробуйте снова.',
        passphrase_confirmed_qr: 'Кодовое слово подтверждено. Отсканируйте QR и введите код из Proton.',
        passphrase_confirmed_code: 'Кодовое слово подтверждено. Введите код из Proton.',
        passphrase_too_short: 'Кодовое слово слишком короткое. Минимум 4 символа.',
        passphrase_saved: 'Кодовое слово сохранено. Подтвердите буквы.',
        totp_invalid: 'Код из Proton неверный. Попробуйте ещё раз.',
        login_success: 'Успешный вход. Перенаправляем...',
        email_invalid: 'Некорректный email.',
        user_not_found: 'Пользователь с таким email не найден.',
        auth_method_disabled: 'Авторизация через email отключена для этого аккаунта.',
        generic_error: 'Ошибка. Попробуйте позже.',
        code_sent: 'Код отправлен на ваш email.',
        wait_seconds: 'Подождите {s} сек.',
        send_error: 'Ошибка отправки.',
        code_resent: 'Код отправлен повторно.',
        too_many_attempts: 'Слишком много попыток. Подождите {s} сек.',
        otp_expired: 'Код не подошёл или истёк.',
        min4: 'Минимум 4 символа.',
        passphrase_saved_confirm: 'Кодовое слово сохранено. Подтвердите.',
        letters_wrong: 'Буквы не совпали.',
        enter_proton_code: 'Введите код из Proton Authenticator.',
        totp_wrong_backup: 'Неверный код. Резервных кодов: {n}',
        totp_wrong: 'Код неверный.',
        reg_complete: 'Регистрация завершена, перенаправляем...',
        email_send_error: 'Ошибка отправки. Попробуйте позже.',
        otp_expired_retry: 'Код не подошёл или истёк. Запросите новый.',
        backup_code_hint: 'Введите один из резервных кодов (формат XXXX-XXXX)',
        app_code_hint: 'Код из Proton Authenticator',
      },
    },
    dashboard: {
      title: 'Мои ключи',
      empty: 'У вас пока нет ключей',
      empty_hint: 'Активируйте код подписки или сервера',
      refresh: 'Обновить',
      rebuild: 'Пересобрать ключи',
      loading: 'Загрузка...',
      copy: 'Скопировать',
      copied: 'Скопировано',
      expired: 'Истёк',
      expires_at: 'Действует до',
    },
    activate: {
      title: 'Активация кода',
      placeholder: 'Введите код активации',
      submit: 'Активировать',
      processing: 'Обработка...',
      success: 'Код активирован',
      already: 'Срок продлён',
      already_by_you: 'Этот код вы уже активировали ранее',
      back_to_keys: 'К ключам',
      modal: {
        success_title: 'Готово! Код активирован',
        extended_title: 'Код активирован',
        already_title: 'Вы уже активировали этот код',
        server: 'Сервер',
        location: 'Локация',
        valid_until: 'Срок действия',
        keys_created: 'Создано ключей',
        keys_updated: 'Продлено ключей',
        protocols: 'Протоколов на сервере',
        go_to_keys: 'Перейти к моим ключам',
        another_code: 'Ввести ещё код',
        close: 'Закрыть',
        pick_title: 'Выберите сервер',
        pick_hint: 'Выберите сервер. Хеш и ключи создаются только после подтверждения.',
        pick_server_label: 'Сервер',
        pick_submit: 'Создать ключи',
        pick_processing: 'Создание ключей…',
        pick_offline: 'офлайн',
        pick_online: 'онлайн',
        free_badge: 'Свободный сервер',
        free_hint: 'Этот код не привязан к серверу. Выберите любой из доступных свободных серверов.',
        renewal_badge: 'Продление',
        renewal_pick_title: 'Выберите сервер для продления',
        renewal_pick_hint: 'Код продления принят. Выберите свободный сервер, который нужно продлить.',
        renewal_confirm_title: 'Подтвердите продление',
        renewal_confirm_hint: 'Срок действия ключей на выбранном сервере будет увеличен. Продолжить?',
        renewal_confirm_submit: 'Продлить',
        renewal_processing: 'Продление…',
        renewal_days: 'Срок продления',
        renewal_expires: 'Текущий срок',
        renewal_success_title: 'Ключ продлён',
        step_activate: 'Активация',
        step_pick: 'Выбор сервера',
        step_confirm: 'Подтверждение',
        next: 'Далее',
        back: 'Назад',
        confirm_title: 'Подтвердите выбор',
        confirm_hint: 'Ключи будут созданы на выбранном сервере. Продолжить?',
        confirm_server: 'Выбранный сервер',
        confirm_create: 'Создать ключи',
        selected: 'Выбран',
        select_prompt: 'Нажмите на сервер, чтобы выбрать его',
        no_servers: 'Нет доступных серверов',
        no_renewal_servers: 'Нет свободных серверов для продления',
        days_short: '{n} дн.',
      },
    },
    common: {
      error: 'Ошибка',
    },
  },
}

export const i18n = createI18n({
  legacy: false,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages,
})
